export interface SeparatedNumber {
  number: number;
  decimal: number;
}

// Splits a given number into two parts. Value and decimal part
export function separateDecimal(decimal: number): SeparatedNumber {
  const number = Math.floor(decimal);
  const decimalPart = decimal - number;
  return {
    number: number,
    decimal: decimalPart,
  };
}
